import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!
const supabaseServiceKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE!

// Create a Supabase client with service role key to bypass RLS
export const supabase = createClient(supabaseUrl, supabaseServiceKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false
  }
})

// Database types
export interface User {
  id: string // Required for authenticated users
  email: string
  password?: string
  firstName: string
  lastName: string
  phoneNumber?: string
  schoolId?: string
  role: 'coach' | 'headteacher' | 'headmaster' | 'admin'
  isActive?: boolean
  created_at?: string
  updated_at?: string
}

export interface AuthResponse {
  success: boolean
  message: string
  user?: User
  error?: string
}
